import { PAxiosInstance } from "@core/types";
import axios from "axios";
// import { useCustomerAddressesStorageState } from "../../../../providers/customerAddressesStorage/useCustomerAddressesStorage";


// import { authContextInstance } from "../../../../contexts/auth-context/AuthContextProvider";

import { Config } from "../config";

const headers = {
  "Content-Type": "application/json",
};

export const httpClient = axios.create({
  baseURL: Config.baseUrl,
  headers,
}) as PAxiosInstance;

httpClient.interceptors.request.use((config) => {
  if (httpClient.token) {
    config.headers!.Authorization = `Bearer ${httpClient.token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    const status = err?.status || err.response?.status;
    if (status === 403 || status === 401) {
      // useCustomerAddressesStorageState.persist.clearStorage();
      // useCustomerAddressesStorageState.getState().resetAuthedCustomerAddresses();
      // authContextInstance.logout();
    } else {
      throw err;
    }
  },
);
